import { ftpAPI } from '@/api';
import { ErrorService } from '@/services/error-service.js';

/**************** STATE *******************/
const state = {
  ftpChoicesLoading: false,
  ftpChoices: [],

  currentFTP: null
};

/**************** GETTERS *******************/
const getters = {};

/**************** MUTATIONS *******************/
const mutations = {
  

  SET_CURRENT_FTP: (state, payload) => {
    state.currentFTP = payload;
  }
};

/**************** ACTIONS *******************/
const actions = {


  START_CREATE_DATA: async ({ commit }, { data }) => {
    const createdFTP = await ftpAPI.createFTPFormat(data);
    commit('SET_CURRENT_FTP', createdFTP);

    return createdFTP.id;
  },
  FINISH_CREATE_DATA: async ({ state, commit }, { scenarioId, data }) => {
    // Run scenario
    await ftpAPI.runFTPResourceScenario(state.currentFTP.id, scenarioId, data);
    ErrorService.onSuccess(
      state.currentFTP.id,
      `La création de la ressource <b>${state.currentFTP.resource.codename}</b> a été lancée avec succès.`
    );
    commit('SET_CURRENT_FTP', null);
  },

  START_MODIFY_DATA: async ({ commit }, { data }) => {    
    const updatedFTP = await ftpAPI.updateFTPFormat(data.id, { dataformat_id: data.format.id });
    commit('SET_CURRENT_FTP', updatedFTP);

    return updatedFTP.id;
  },
  FINISH_MODIFY_DATA: async ({ state, commit }, { scenarioId, data }) => {
    // Run scenario
    await ftpAPI.runFTPResourceScenario(state.currentFTP.id, scenarioId, data);
    ErrorService.onSuccess(
      state.currentFTP,
      `La mise à jour de la ressource <b>${state.currentFTP.resource.codename}</b> a été lancée avec succès.`
    );
    commit('SET_CURRENT_FTP', null);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};